import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type PinnedSearchItem = {
	id: string;
	type: "shipment" | "invoice" | "quote" | "arrival_calendar";
	name: string;
	url: string;
	subtitle?: string;
};

interface PinnedSearchState {
	items: PinnedSearchItem[];
}

const MAX_PINS = 12;

const initialState: PinnedSearchState = {
	items: [],
};

const pinnedSearchSlice = createSlice({
	name: "pinnedSearch",
	initialState,
	reducers: {
		togglePin(state, action: PayloadAction<PinnedSearchItem>) {
			const incoming = action.payload;
			const idx = state.items.findIndex(
				(p) => p.id === incoming.id && p.type === incoming.type,
			);
			if (idx >= 0) {
				state.items.splice(idx, 1);
			} else {
				state.items.unshift(incoming);
				if (state.items.length > MAX_PINS) {
					state.items = state.items.slice(0, MAX_PINS);
				}
			}
		},
		unpinAll(state) {
			state.items = [];
		},
	},
});

export const { togglePin, unpinAll } = pinnedSearchSlice.actions;
export default pinnedSearchSlice.reducer;
